import { Link } from 'react-router-dom';

export function FinalCTA() {
  return (
    <section className="relative py-24 px-6 lg:px-8">
      {/* Visual connector line */}
      <div className="sc" aria-hidden="true">
        <svg width="2" height="24" viewBox="0 0 2 24">
          <line x1="1" y1="0" x2="1" y2="24" className="sc-line" stroke="#2563EB" strokeOpacity="0.3" strokeWidth="1.5" />
        </svg>
        <span className="sc-node" />
      </div>

      <div className="max-w-4xl mx-auto bg-ink rounded-xl3 px-8 sm:px-10 py-16 text-center shadow-premium">
        <h2 className="text-[28px] sm:text-[36px] font-extrabold tracking-tight text-white leading-[1.15]">
          The next time a regulator asks about<br className="hidden sm:block" /> your consent posture, you'll have the answer.
        </h2>
        <p className="mt-4 text-[15px] text-[#9CA3AF] leading-relaxed">
          Request access. We'll reach out within one business day.
        </p>

        <div className="mt-8 flex justify-center">
          <Link to="/register" className="btn-p text-[14.5px]">
            Request Access{' '}
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>

        <p className="mt-6 mono text-[11px] text-[#4B5563]">
          Limited access · India DPDP Act, 2023 · v1.4.2 · Mumbai · Bengaluru · Delhi NCR
        </p>
      </div>
    </section>
  );
}
